import React, { Component, Fragment } from "react";
import CheckAuth from "../../../utils/hoc/CheckAuth";
import Loading from "../../../components/molecules/Loading";
import ModalTermCondition from "../../organism/ModalTermCondition";
import { connect } from "react-redux";

class Dashboard extends Component {
	componentDidMount = () => {
		this.props.setTitlePage({
			title: "Beranda",
			breadcrumb: [{ name: "Beranda", url: "/#", status: true }],
		});
	};
	componentDidUpdate = () => {
		console.log(this.props.profile);
	};

	render() {
		const { status, TnCState, profile } = this.props;

		return (
			<Fragment>
				{TnCState.isLoading || status.loadingPage || profile.isLoading ? (
					<Loading />
				) : (
					profile.list && (
						<h2 className="label-kc">
							Hai <b>{profile.list.picDetail.fullName ? profile.list.picDetail.fullName : "Calon Peminjam"}</b>, selamat datang di KlikCair.
						</h2>
					)
				)}

				<ModalTermCondition />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		TnCState: state.tnc,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {};
};
export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
